module.exports = __webpack_public_path__ + "images/category_lp/tablet/store_images/2_3f7e3c0dde6f6407b802f16cae628d01.png";